import React from 'react';
// import { connect } from 'react-redux';
// import { forgetPassword } from '../../../Action/forgetPassword';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import { LoginHeader } from '../Common';

class RegistrationSuccessMessage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div>
                <div className="container-fluid mb-5 pb-5">
                    <div className="container">
                        <div className="col-md-12">
                            <div>
                                <LoginHeader />
                            </div>
                        </div>
                        <div className="row mt-5">
                            <div className="col-md-12 tr_blank_big">
                                <div className="">

                                </div>
                            </div>
                            <div className="col-md-12 tr_blank_big">
                                <div className="">
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-3">
                                    </div>
                                    <div className="col-md-6 form-group "style={{height:'420px'}}>
                                        <div className="reg_first"><b>Registration Success Message</b></div>
                                        <div className="dots">
                                            <hr />
                                        </div>
                                        <div className="margin_manage">
                                            <span className="weighted_text"><b>Please Check Your mail. Thank You</b></span>
                                        </div>
                                    </div>
                                    <div className="col-md-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" mt-5 pt-5">

                    <Footer />
                </div>
            </div>
        )
    }
}
export { RegistrationSuccessMessage }